import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FiSearch, FiChevronDown, FiChevronUp, FiKey, FiMapPin } from "react-icons/fi";
import { HiOutlineHome, HiOutlineUsers, HiOutlineOfficeBuilding } from "react-icons/hi";
import { BsShieldCheck, BsBuildings } from "react-icons/bs";
import { MdOutlineLocationOn, MdApartment } from "react-icons/md";
import { FaRegHandshake } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import {
  searchPost,
  setSearchComponentStatus,
  setcommercialStatus,
  setsearchObjects,
} from "../../redux/search/SearchSlice";

import MainSearchcomponents from "./MainSearchcomponents";
import {
  setPropertySearchBySelectionCat,
  setsingleProperty,
} from "../../redux/property/PropertySlice";
import { getSubCategory } from "../../redux/subCategory/SubCategorySlice";
import "./HomeBannerNew.css";

const HERO_BG_IMAGES = [
  "/assets/images/hero_banner_user.png?v=7",
  "/assets/images/hero_slide_4.jpg?v=7",
  "/assets/images/hero_slide_2.jpg?v=7",
  "/assets/images/hero_slide_3.jpg?v=7",
];

const HomeBanner = () => {
  const { isAuth, loginData } = useSelector((store) => store.Athentication);
  const { propertySearchBySelectionCat } = useSelector(
    (store) => store.Property
  );
  const { searchComponentStatus, commercialStatus } = useSelector(
    (state) => state.Search
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const ref = useRef();
  const mainref = useRef();
  const categoryDropdownRef = useRef();

  const [showResults, setShowResults] = useState(false);
  const [mainshowResults, setMainShowResults] = useState(false);
  const [toggle, setToggle] = useState(false);

  // Background fade slider state & preloading
  const [currentBgIndex, setCurrentBgIndex] = useState(0);

  useEffect(() => {
    HERO_BG_IMAGES.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    const interval = setInterval(() => {
      setCurrentBgIndex((prev) => (prev + 1) % HERO_BG_IMAGES.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const [search, setSearch] = useState("");
  const [searchArray, setSearchArray] = useState([]);
  const [showresult, setShowresult] = useState(false);
  const [selectedHeader, setSelectedHeader] = useState("Buy");
  const [commerChange, setcommerChange] = useState(false);

  const [supercat, setSupercat] = useState("Residential");
  const [cat, setCat] = useState("Sell");
  const [checkboxArray, setCheckboxArray] = useState([]);

  const [propertySearch, setPropertySearch] = useState([]);
  const [propertySearchShow, setPropertySearchShow] = useState([]);
  const [propertySearchProject, setPropertySearchProject] = useState([]);

  const [selectedSubcat, setSelectedSubcat] = useState([]);
  const [selectedBedrooms, setSelectedBedrooms] = useState([]);
  const [selectedConustruction, setSelectedConustruction] = useState([]);
  const [selectedPostedBy, setSelectedPostedBy] = useState([]);
  const [propertyPrice, setPropertyPrice] = useState([]);
  const [selectedFurnished, setSelectedFurnished] = useState([]);
  const [selectedSharing, setSelectedSharing] = useState([]);
  const [selectedAvailables, setSelectedAvailables] = useState([]);
  const [selectedSeatType, setselectedSeatType] = useState([]);
  const [selectedNoSeat, setselectedNoSeat] = useState([]);
  const [selectedPlan, setselectedPlan] = useState([]);
  const [selectLand, setSelectLand] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectProjectStatus, setSelectProjectStatus] = useState([]);

  const [propertySearchShowByCity, setPropertySearchShowByCity] = useState([]);
  const [propertyShowByApart, setPropertyShowByApart] = useState([]);
  const [showAllApart, setShowAllApart] = useState([]);
  const [citylist, setCitylist] = useState([]);

  // Category Selection States
  const [buy, setBuy] = useState(true);
  const [rent, setRent] = useState(false);
  const [pg_coliving, setpg_coliving] = useState(false);
  const [commercial, setCommercial] = useState(false);
  const [coworking, setCoworking] = useState(false);
  const [plots_land, setPlots_lands] = useState(false);
  const [projects, setProjects] = useState(false);

  const handleBuy = () => {
    setBuy(true);
    setRent(false);
    setpg_coliving(false);
    setCommercial(false);
    setCoworking(false);
    setPlots_lands(false);
    setProjects(false);
  };
  const handleRent = () => {
    setBuy(false);
    setRent(true);
    setpg_coliving(false);
    setCommercial(false);
    setCoworking(false);
    setPlots_lands(false);
    setProjects(false);
  };
  const handlepg_coliving = () => {
    setBuy(false);
    setRent(false);
    setpg_coliving(true);
    setCommercial(false);
    setCoworking(false);
    setPlots_lands(false);
    setProjects(false);
  };
  const handleCommercial = () => {
    setBuy(false);
    setRent(false);
    setpg_coliving(false);
    setCommercial(true);
    setCoworking(false);
    setPlots_lands(false);
    setProjects(false);
  };
  const handleCoworking = () => {
    setBuy(false);
    setRent(false);
    setpg_coliving(false);
    setCommercial(false);
    setCoworking(true);
    setPlots_lands(false);
    setProjects(false);
  };
  const handlePlots_land = () => {
    setBuy(false);
    setRent(false);
    setpg_coliving(false);
    setCommercial(false);
    setCoworking(false);
    setPlots_lands(true);
    setProjects(false);
  };
  const handleProjects = () => {
    setBuy(false);
    setRent(false);
    setpg_coliving(false);
    setCommercial(false);
    setCoworking(false);
    setPlots_lands(false);
    setProjects(true);
  };

  useEffect(() => {
    const clickoutside = (e) => {
      if (showResults && ref.current && !ref.current.contains(e.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener("click", clickoutside);
    return () => {
      document.removeEventListener("click", clickoutside);
    };
  }, [showResults]);

  // Click outside listener for category filter dropdown
  useEffect(() => {
    const handleCategoryOutsideClick = (e) => {
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(e.target)
      ) {
        setToggle(false);
      }
    };
    if (toggle) {
      document.addEventListener("mousedown", handleCategoryOutsideClick);
      document.addEventListener("touchstart", handleCategoryOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleCategoryOutsideClick);
      document.removeEventListener("touchstart", handleCategoryOutsideClick);
    };
  }, [toggle]);

  // Initial preload for cities, localities, and apartments
  useEffect(() => {
    const fetchData = async () => {
      dispatch(getSubCategory());
      try {
        const url = `${Baseurl}/api/v1/property/allcities`;
        const fetchProperty = await axios.get(url);
        if (fetchProperty?.data?.success === true) {
          const cityresult = fetchProperty.data.cities;
          setCitylist(cityresult || []);
        }
      } catch (error) {}

      try {
        const urlLoc = `${Baseurl}/api/v1/property/localitieswithcity`;
        const fetchLoc = await axios.get(urlLoc);
        if (fetchLoc?.data?.success === true) {
          const searchresult = fetchLoc.data.locality;
          setPropertySearch(searchresult || []);
        }
      } catch (error) {}

      try {
        const urlApart = `${Baseurl}/api/v1/property/apartmentswithcity`;
        const fetchApart = await axios.get(urlApart);
        if (fetchApart?.data?.success === true) {
          const searchresult = fetchApart.data.apartment;
          setShowAllApart(searchresult || []);
        }
      } catch (error) {}
    };
    fetchData();
  }, []);

  // Filter search suggestions based on query
  useEffect(() => {
    const query = search.trim().toLowerCase();

    if (query !== "") {
      if (propertySearch && propertySearch.length > 0) {
        const searchfilter = propertySearch.filter((item) =>
          item?.locality && typeof item.locality === "string" && item.locality.toLowerCase().includes(query)
        );
        const updatedSearchfilter = searchfilter.map((item) => ({
          ...item,
          locality:
            item.locality.charAt(0).toUpperCase() + item.locality.slice(1),
        }));
        setPropertySearchShow(updatedSearchfilter.slice(0, 5));
      } else {
        setPropertySearchShow([]);
      }

      if (showAllApart && showAllApart.length > 0) {
        const searchfilterbyapart = showAllApart.filter((item) =>
          item?.apartment && typeof item.apartment === "string" && item.apartment.toLowerCase().includes(query)
        );
        setPropertyShowByApart(searchfilterbyapart.slice(0, 5));
      } else {
        setPropertyShowByApart([]);
      }

      if (citylist && citylist.length > 0) {
        const searchfilterbycity = citylist.filter((item) =>
          typeof item === "string" && item.toLowerCase().includes(query)
        );
        setPropertySearchShowByCity(searchfilterbycity.slice(0, 5));
      } else {
        setPropertySearchShowByCity([]);
      }
    } else {
      // Show default popular localities & cities when search is empty
      if (citylist && citylist.length > 0) {
        setPropertySearchShowByCity(citylist.slice(0, 3));
      } else {
        setPropertySearchShowByCity(["Hyderabad", "Secunderabad"]);
      }

      if (propertySearch && propertySearch.length > 0) {
        setPropertySearchShow(propertySearch.slice(0, 5));
      } else {
        setPropertySearchShow([
          { locality: "Gachibowli", city: "Hyderabad" },
          { locality: "Madhapur", city: "Hyderabad" },
          { locality: "Hitec City", city: "Hyderabad" },
          { locality: "Kondapur", city: "Hyderabad" },
          { locality: "Banjara Hills", city: "Hyderabad" },
        ]);
      }
      setPropertyShowByApart([]);
      setPropertySearchProject([]);
    }
  }, [propertySearch, search, citylist, showAllApart]);

  useEffect(() => {
    dispatch(setsingleProperty(""));
  }, [dispatch]);

  useEffect(() => {
    const clickoutside = (e) => {
      if (
        mainshowResults &&
        mainref.current &&
        !mainref.current.contains(e.target)
      ) {
        setMainShowResults(false);
        setToggle(false);
      }
    };
    document.addEventListener("click", clickoutside);
    return () => {
      document.removeEventListener("click", clickoutside);
    };
  }, [mainshowResults]);

  // For Search bar project suggestions when typing
  useEffect(() => {
    if (search.trim().length >= 2) {
      const fetchPropertyByProjects = async () => {
        try {
          const url = `${Baseurl}/api/v1/property/allPropertyproject/${search.trim()}`;
          const fetchProperty = await axios.get(url);
          if (fetchProperty?.data?.success === true) {
            const searchresult = fetchProperty.data.properties;
            setPropertySearchProject(searchresult || []);
          }
        } catch (error) {}
      };
      fetchPropertyByProjects();
    } else {
      setPropertySearchProject([]);
    }
  }, [search]);

  const storeAllApartInarray = (e, data) => {
    let apartmentArray = [];
    if (searchArray.length > 0) {
      const findserchname = searchArray.filter(
        (seitem) => seitem === data.apartment
      );
      if (findserchname.length === 0) {
        apartmentArray = [data.apartment, ...searchArray];
        setSearchArray(apartmentArray);
      }
    } else {
      apartmentArray = [data.apartment];
      setSearchArray(apartmentArray);
    }
    setSearch("");
    setShowResults(false);
  };

  const storeCityAllInarray = (e, data) => {
    let cityarray = [];
    if (searchArray.length > 0) {
      const findserchname = searchArray.filter((seitem) => seitem === data);
      if (findserchname.length === 0) {
        cityarray = [data, ...searchArray];
        setSearchArray(cityarray);
      }
    } else {
      cityarray = [data];
      setSearchArray(cityarray);
    }
    setSearch("");
    setShowResults(false);
  };

  const storeCityInarray = (e, data) => {
    let localirtarray = [];
    if (searchArray.length > 0) {
      const findserchname = searchArray.filter(
        (seitem) => seitem === data.locality
      );
      if (findserchname.length === 0) {
        localirtarray = [data.locality, ...searchArray];
        setSearchArray(localirtarray);
      }
    } else {
      localirtarray = [data.locality];
      setSearchArray(localirtarray);
    }

    setSearch("");
    setShowResults(false);
  };

  const removesearch = (data) => {
    const filteredArr = searchArray.filter((item) => item !== data);
    setSearchArray(filteredArr);
  };

  const residential = (e, value) => {
    setSupercat("Residential");
    if (value === "Buy") {
      setCat("Sell");
    } else if (value === "Rent") {
      setCat("Rent");
    } else if (value === "PG/Co-living") {
      setCat("PG/Co-living");
    } else if (value === "Coworking") {
      setCat("Coworking");
    } else if (value === "Plots/Land") {
      setCat("Sell");
    } else if (value === "Projects") {
      setCat("Sell");
    }
  };

  const commercialClick = () => {
    setcommerChange(!commerChange);

    if (commerChange === false) {
      setCat("Sell");
      setSupercat("Commercial");
    }
  };

  const searchRedirect = (e, data) => {
    e.preventDefault();

    const apartName =
      data.apartment && typeof data.apartment === "string" && data.apartment.trim() !== ""
        ? data.apartment.trim()
        : data.propertyID || "commercial";
    navigate(`/property-info/${apartName}/${data.propertyID}`);

    if (isAuth) {
      const formdata = {
        userId: loginData._id,
        name: loginData.name,
        userMobile: loginData.mobile,
        propertyId: data._id,
        city: data.city,
        locality: data.locality,
        apartment: data.apartment,
      };
      dispatch(searchPost(formdata));
      setShowResults(false);
    }
  };

  const projectRedirect = (e, data) => {
    e.preventDefault();

    navigate(`/project-info/${data.apartment}`);

    if (isAuth) {
      const formdata = {
        userId: loginData._id,
        name: loginData.name,
        userMobile: loginData.mobile,
        propertyId: data._id,
        city: data.city,
        locality: data.locality,
        apartment: data.apartment,
      };
      dispatch(searchPost(formdata));
      setShowResults(false);
    }
  };

  const searchChange = (e) => {
    const result = e.target.value;
    setSearch(result);
    setShowResults(true);
  };

  const searchClick = (e) => {
    if (e) e.preventDefault();
    let findsearch = search;
    if (findsearch === "") {
      findsearch = "Hyderabad";
    }

    let mysubcat = "All";
    if (checkboxArray.length > 0) {
      mysubcat = checkboxArray.join();
      mysubcat = mysubcat.replaceAll(",", "-");
      mysubcat = mysubcat.replaceAll("/", "-");
      mysubcat = mysubcat.replaceAll(" ", "-");
    }

    let finalLocalityArray = [];
    if (searchArray.length === 0) {
      finalLocalityArray = ["Hyderabad"];
    } else {
      finalLocalityArray = searchArray;
    }

    const searchFormdta = {
      selectedSubcat: selectedSubcat,
      selectedCity: finalLocalityArray,
      selectedBedrooms: selectedBedrooms,
      selectedConustruction: selectedConustruction,
      selectedPostedBy: selectedPostedBy,
      propertyPrice: propertyPrice,
      selectedSharing: selectedSharing,
      selectedAvailables: selectedAvailables,
      selectedFurnished: selectedFurnished,
      selectedSeatType: selectedSeatType,
      selectedPlan: selectedPlan,
      selectedNoSeat: selectedNoSeat,
      selectLand: selectLand,
      selectedArea: selectedArea,
      selectProjectStatus: selectProjectStatus,
    };

    dispatch(setsearchObjects(searchFormdta));
    if (propertySearchBySelectionCat === "") {
      navigate(`/property-search/${supercat}/${cat}/${mysubcat}/${findsearch}`);
    } else {
      navigate(
        `/property-search/${supercat}/${propertySearchBySelectionCat}/${mysubcat}/${findsearch}`
      );
    }
    dispatch(setPropertySearchBySelectionCat(""));
    setShowresult(false);
    setSelectedHeader("Buy");
    setCheckboxArray([]);
  };

  const searchsubmit = (e) => {
    if (e) e.preventDefault();
    searchClick(e);
  };

  const getDetails = (values) => {};
  const getSubcatDetails = (values) => {
    let mysubcat = "all";
    if (values.length > 0) {
      mysubcat = values.join();
      mysubcat = mysubcat.replaceAll(",", "-");
      mysubcat = mysubcat.replaceAll("/", "&");
      mysubcat = mysubcat.replaceAll(" ", "=");
    }
    setSelectedSubcat(values);
  };
  const getBudgetDetails = (values) => {
    setPropertyPrice(values);
  };
  const getBedRoomDetails = (values) => {
    setSelectedBedrooms(values);
  };
  const getConustructionDetails = (values) => {
    setSelectedConustruction(values);
  };
  const getPostedDetailsDetails = (values) => {
    setSelectedPostedBy(values);
  };
  const getFurnishedDetails = (values) => {
    setSelectedFurnished(values);
  };
  const getSharingDetails = (values) => {
    setSelectedSharing(values);
  };
  const getavailabilityDetails = (values) => {
    setSelectedAvailables(values);
  };
  const getProjectStatusDetails = (values) => {
    setSelectProjectStatus(values);
  };
  const getAreaDetails = (values) => {
    setSelectedArea(values);
  };
  const getLandDetails = (values) => {
    setSelectLand(values);
  };
  const getNoSeatDetails = (values) => {
    setselectedNoSeat(values);
  };
  const getSeatTypeDetails = (values) => {
    setselectedSeatType(values);
  };
  const getPlansDetails = (values) => {
    setselectedPlan(values);
  };

  return (
    <div className="mgh-hero-container">
      {/* Smooth Background Fade Carousel */}
      <div className="mgh-hero-bg-slider" aria-hidden="true">
        {HERO_BG_IMAGES.map((imgSrc, idx) => (
          <div
            key={imgSrc}
            className={`mgh-hero-bg-slide ${idx === currentBgIndex ? "active" : ""}`}
            style={{ backgroundImage: `url('${imgSrc}')` }}
          />
        ))}
        <div className="mgh-hero-bg-overlay" />
      </div>

      <div className="mgh-hero-content-wrap">
        {/* Tagline */}
        <div className="mgh-hero-tagline">
          <span className="mgh-tagline-bar"></span>
          <span>Real Estate Searching Platform</span>
        </div>

        {/* Title */}
        <h1 className="mgh-hero-title">
          Find The House of <span className="mgh-gold-highlight">Your Dream</span>{" "}
          <br className="mgh-hero-br" />
          Using Our Platform
        </h1>


        {/* Centered Search Card Container */}
        <div className="mgh-search-card" ref={mainref}>
          {/* Top Tabs */}
          <div className="mgh-tabs-row">
            <button
              type="button"
              className={`mgh-tab-btn ${buy ? "active" : ""}`}
              onClick={(e) => {
                handleBuy();
                residential(e, "Buy");
                setSelectedHeader("Buy");
                dispatch(setSearchComponentStatus(0));
                setToggle(false);
              }}
            >
              <HiOutlineHome className="mgh-tab-icon" />
              <span>BUY</span>
            </button>

            <button
              type="button"
              className={`mgh-tab-btn ${rent ? "active" : ""}`}
              onClick={(e) => {
                handleRent();
                residential(e, "Rent");
                setSelectedHeader("Rent");
                dispatch(setSearchComponentStatus(1));
                setToggle(false);
              }}
            >
              <FiKey className="mgh-tab-icon" />
              <span>RENT</span>
            </button>

            <button
              type="button"
              className={`mgh-tab-btn ${pg_coliving ? "active" : ""}`}
              onClick={(e) => {
                handlepg_coliving();
                residential(e, "PG/Co-living");
                setCat("Pg");
                setSelectedHeader("PG");
                dispatch(setSearchComponentStatus(2));
                setToggle(false);
              }}
            >
              <HiOutlineUsers className="mgh-tab-icon" />
              <span>PG/CO-LIVING</span>
            </button>

            <button
              type="button"
              className={`mgh-tab-btn ${commercial ? "active" : ""}`}
              onClick={(e) => {
                handleCommercial();
                commercialClick(e);
                setSelectedHeader("commercial");
                dispatch(setSearchComponentStatus(3));
                setToggle(false);
              }}
            >
              <HiOutlineOfficeBuilding className="mgh-tab-icon" />
              <span>COMMERCIAL</span>
            </button>

            <button
              type="button"
              className={`mgh-tab-btn ${plots_land ? "active" : ""}`}
              onClick={(e) => {
                handlePlots_land();
                residential(e, "Plots/Land");
                setCheckboxArray(["Plot", "Land"]);
                setSelectedHeader("Plots/Land");
                dispatch(setSearchComponentStatus(5));
                setToggle(false);
              }}
            >
              <MdOutlineLocationOn className="mgh-tab-icon" />
              <span>PLOTS/LAND</span>
              <span className="mgh-new-badge">NEW</span>
            </button>

            <button
              type="button"
              className={`mgh-tab-btn ${projects ? "active" : ""}`}
              onClick={(e) => {
                handleProjects();
                residential(e, "Projects");
                setSelectedHeader("Projects");
                dispatch(setSearchComponentStatus(6));
                setToggle(false);
              }}
            >
              <BsBuildings className="mgh-tab-icon" />
              <span>PROJECTS</span>
            </button>
          </div>

          {/* Search Inputs Row */}
          <form onSubmit={searchsubmit} className="mgh-search-bar-wrap">
            <div className="mgh-search-bar">
              {/* Category Dropdown */}
              <div
                className="mgh-category-wrap"
                ref={categoryDropdownRef}
                style={{ position: "relative" }}
              >
                {searchComponentStatus === 3 ? (
                  <div className="mgh-commercial-btn-group">
                    <button
                      type="button"
                      className="mgh-category-select-btn"
                      onClick={() => {
                        dispatch(setcommercialStatus(0));
                        setToggle(!toggle);
                        setMainShowResults(true);
                      }}
                    >
                      <span>Buy</span>
                      {!toggle && commercialStatus === 0 ? (
                        <FiChevronDown />
                      ) : (
                        <FiChevronUp />
                      )}
                    </button>
                    <button
                      type="button"
                      className="mgh-category-select-btn"
                      onClick={() => {
                        dispatch(setcommercialStatus(1));
                        setToggle(!toggle);
                        setMainShowResults(true);
                      }}
                    >
                      <span>All Commercial</span>
                      {!toggle && commercialStatus === 1 ? (
                        <FiChevronUp />
                      ) : (
                        <FiChevronDown />
                      )}
                    </button>
                  </div>
                ) : (
                  <button
                    type="button"
                    className="mgh-category-select-btn"
                    onClick={() => {
                      setToggle(!toggle);
                      setMainShowResults(true);
                    }}
                  >
                    <span>
                      {searchComponentStatus === 5
                        ? "Plots / Land"
                        : searchComponentStatus === 6
                        ? "Projects"
                        : searchComponentStatus === 2
                        ? "PG / Co-living"
                        : "All Residential"}
                    </span>
                    {!toggle ? <FiChevronDown /> : <FiChevronUp />}
                  </button>
                )}

                {/* Advanced Filter Component Dropdown */}
                {mainshowResults && toggle && (
                  <div
                    className="mgh-filter-dropdown-menu"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="mgh-filter-dropdown-top">
                      <div className="mgh-filter-header-text">
                        <span className="mgh-filter-title">
                          {searchComponentStatus === 5
                            ? "Plots & Land Filters"
                            : searchComponentStatus === 6
                            ? "Project Filters"
                            : searchComponentStatus === 3
                            ? "Commercial Filters"
                            : searchComponentStatus === 2
                            ? "PG / Co-Living Filters"
                            : "Property Filters"}
                        </span>
                        <span className="mgh-filter-subtitle">
                          Customise type, budget & details
                        </span>
                      </div>
                      <button
                        type="button"
                        className="mgh-filter-close-btn"
                        onClick={() => setToggle(false)}
                        aria-label="Close filters"
                        title="Close"
                      >
                        <RxCross2 />
                      </button>
                    </div>

                    <div className="mgh-filter-dropdown-body">
                      <MainSearchcomponents
                        getDetails={getDetails}
                        getSubcatDetails={getSubcatDetails}
                        getBudgetDetails={getBudgetDetails}
                        getBedRoomDetails={getBedRoomDetails}
                        getConustructionDetails={getConustructionDetails}
                        getPostedDetailsDetails={getPostedDetailsDetails}
                        getFurnishedDetails={getFurnishedDetails}
                        getSharingDetails={getSharingDetails}
                        getavailabilityDetails={getavailabilityDetails}
                        getProjectStatusDetails={getProjectStatusDetails}
                        getAreaDetails={getAreaDetails}
                        getLandDetails={getLandDetails}
                        getNoSeatDetails={getNoSeatDetails}
                        getSeatTypeDetails={getSeatTypeDetails}
                        getPlansDetails={getPlansDetails}
                      />
                    </div>

                    <div className="mgh-filter-dropdown-footer">
                      <button
                        type="button"
                        className="mgh-filter-apply-btn"
                        onClick={() => setToggle(false)}
                      >
                        Apply Filters
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Divider */}
              <div className="mgh-search-divider" />

              {/* Input field + Chips */}
              <div className="mgh-search-input-wrap" ref={ref}>
                <FiSearch className="mgh-search-icon-left" />

                {searchArray.length > 0 && (
                  <div className="mgh-search-chips">
                    <div className="mgh-search-chip">
                      <span>{searchArray[0]}</span>
                      <RxCross2
                        onClick={() => removesearch(searchArray[0])}
                        size={14}
                      />
                    </div>
                    {searchArray.length > 1 && (
                      <div className="mgh-search-chip">
                        <span>+{searchArray.length - 1} More</span>
                      </div>
                    )}
                  </div>
                )}

                <input
                  type="text"
                  name="keyword"
                  className="mgh-search-input"
                  autoComplete="off"
                  placeholder='Search "Hyderabad"'
                  value={search}
                  onChange={searchChange}
                  onFocus={() => setShowResults(true)}
                  onClick={() => setShowResults(true)}
                />

                {/* Suggestions Popover */}
                {showResults &&
                  (propertySearchShowByCity.length > 0 ||
                    propertySearchShow.length > 0 ||
                    propertyShowByApart.length > 0 ||
                    propertySearchProject.length > 0) && (
                    <div className="mgh-suggestions-dropdown">
                      <div className="mgh-suggestions-header">
                        {search.trim() ? "Search Suggestions" : "Popular Locations"}
                      </div>

                      {propertySearchShowByCity.length > 0 &&
                        propertySearchShowByCity.map((city, idx) => (
                          <div
                            className="mgh-suggestion-item"
                            key={`city-${idx}`}
                            onClick={(e) => storeCityAllInarray(e, city)}
                          >
                            <div className="mgh-suggestion-left">
                              <FiMapPin className="mgh-sugg-icon" />
                              <span className="mgh-suggestion-title">{city}</span>
                            </div>
                            <span className="mgh-suggestion-type">City</span>
                          </div>
                        ))}

                      {propertySearchShow.length > 0 &&
                        propertySearchShow.map((data, idx) => (
                          <div
                            className="mgh-suggestion-item"
                            key={`loc-${idx}`}
                            onClick={(e) => storeCityInarray(e, data)}
                          >
                            <div className="mgh-suggestion-left">
                              <MdOutlineLocationOn className="mgh-sugg-icon" />
                              <span className="mgh-suggestion-title">
                                {data.locality}, {data.city}
                              </span>
                            </div>
                            <span className="mgh-suggestion-type">Locality</span>
                          </div>
                        ))}

                      {propertyShowByApart.length > 0 &&
                        propertyShowByApart.map((apart, idx) => (
                          <div
                            className="mgh-suggestion-item"
                            key={`apart-${idx}`}
                            onClick={(e) => storeAllApartInarray(e, apart)}
                          >
                            <div className="mgh-suggestion-left">
                              <HiOutlineHome className="mgh-sugg-icon" />
                              <span className="mgh-suggestion-title">
                                {apart.apartment}
                              </span>
                            </div>
                            <span className="mgh-suggestion-type">
                              {apart.subCategory || "Apartment"}
                            </span>
                          </div>
                        ))}

                      {propertySearchProject.length > 0 &&
                        propertySearchProject.map((data, idx) => (
                          <div
                            className="mgh-suggestion-item"
                            key={`proj-${idx}`}
                            onClick={(e) => projectRedirect(e, data)}
                          >
                            <div className="mgh-suggestion-left">
                              <BsBuildings className="mgh-sugg-icon" />
                              <span className="mgh-suggestion-title">
                                {data.apartment}
                              </span>
                            </div>
                            <span className="mgh-suggestion-type">Project</span>
                          </div>
                        ))}
                    </div>
                  )}
              </div>

              {/* Search Button */}
              <button
                type="button"
                className="mgh-search-submit-btn"
                onClick={searchClick}
              >
                <FiSearch size={16} />
                <span>Search</span>
              </button>
            </div>
          </form>
        </div>
      </div>

    
    </div>
  );
};

export default HomeBanner;
